import React from "react";
import Panel, {PanelCollapsible} from "../Components/Panel.jsx";
import { injectIntl } from "react-intl";
import Nav from "./Nav.jsx";
import GameDetails from 'zweeler-game-details';

const GameDetailsTrigger = ({onClick, intl}) => (
    <a
        className='nav-list__item reverse'
        onClick={onClick}>
        <span className="nav-list__item-name">
            <span className="glyphicon glyphicon-link"/>{intl.formatMessage({ id: "game-details" })}</span>
    </a>
);

const GameDetailsTriggerWithIntl = injectIntl(GameDetailsTrigger);

const NavPanel = ({gameId, collapsible, collapsedByDefault, name, children, isGameDetailMenu = false,  ...rest}) => {
    if (collapsible) {
        return <PanelCollapsible name={name} expanded={!collapsedByDefault}>
            {children}
            <Nav {...rest}/>
        </PanelCollapsible>
    }

    return <Panel name={name}>
        {children}
        {isGameDetailMenu ? (
            <nav className="nav-list nav-list--striped">
                <GameDetails
                    gameId={gameId}
                    render={
                        (onClick) => (
                            <GameDetailsTriggerWithIntl onClick={onClick} />
                        )
                    }
                />
            </nav>
        )
            : null}
        <Nav {...rest}/>
    </Panel>;
};

export default NavPanel;